import { useState } from 'react';
import { reviewService } from '../../services/reviewService';
import StarRating from './StarRating';

const ReviewForm = ({ productId, existingReview, onSaved, onCancel }) => {
  const [rating, setRating] = useState(existingReview?.rating || 0);
  const [title, setTitle] = useState(existingReview?.title || '');
  const [comment, setComment] = useState(existingReview?.comment || '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();

    if (rating < 1) {
      setError('Please select a star rating');
      return;
    }

    try {
      setSubmitting(true);
      setError('');

      if (existingReview) {
        await reviewService.updateReview(existingReview.id, {
          rating,
          title,
          comment,
        });
      } else {
        await reviewService.createReview({
          product_id: productId,
          rating,
          title,
          comment,
        });
      }

      onSaved();
    } catch (err) {
      setError(err.message || 'Failed to save your review');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="review-form" onSubmit={handleSubmit}>
      <div className="review-form-row">
        <span className="review-form-label">Your rating</span>
        <StarRating value={rating} size="lg" onChange={setRating} />
      </div>

      <input
        type="text"
        className="review-form-input"
        placeholder="Title (optional)"
        maxLength={255}
        value={title}
        onChange={e => setTitle(e.target.value)}
      />

      <textarea
        className="review-form-textarea"
        placeholder="Tell others what you thought of this product (optional)"
        rows={4}
        value={comment}
        onChange={e => setComment(e.target.value)}
      />

      {error && <div className="review-form-error">{error}</div>}

      <div className="review-form-actions">
        <button
          type="submit"
          className="review-form-submit"
          disabled={submitting}
        >
          {submitting
            ? 'Saving...'
            : existingReview
              ? 'Update review'
              : 'Submit review'}
        </button>
        {onCancel && (
          <button
            type="button"
            className="review-form-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
};

export default ReviewForm;
